// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./style/style.scss
// module id = 424
// module chunks = 0